import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {setStep} from "../../../redux/actions/stepActions";
import GuestBar from "../../../components/GuestInfo/GuestBar";
import {Breadcrumbs, Container, Grid, Link, Typography,
	Accordion, AccordionSummary, AccordionDetails, Button,
	FormControlLabel,
	Radio, RadioGroup,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
} from "@mui/material";
import GuestInfoStepper from "../../../components/GuestInfo/GuestInfoStepper";
import {Link as RouterLink, useHistory, useParams} from "react-router-dom";
import {getBookingFormData, updateBookingFormData} from "../../../redux/actions/bookingFormActions";
import {useIsAuthenticated} from "react-auth-kit";
import ValidateAccess from "../../../components/ValidateAccess/ValidateAccess";
import {requestApi, showAlertAutoDis, validateForm} from "../../../utils/utils";
import {format, parse, parseISO} from "date-fns";
import PreTripCard from "../../../components/GuestInfo/MyBooking/PreTripCard";
import {makeStyles} from "@mui/styles";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { CheckCircle } from '@mui/icons-material';
import SecondaryButton from "../../../components/Common/SecondaryButton";
import PrimaryButton from "../../../components/Common/PrimaryButton";

import ParkFeeCheckoutForm from "../../../components/Booking/Payment/ParkFeeCheckoutForm";
import {Elements} from "@stripe/react-stripe-js";
import {loadStripe} from "@stripe/stripe-js/pure";
import Icon from '@mui/material/Icon';
import * as yup from "yup";

let billingDetailsValidation = yup.object().shape({
    country: yup.string().required('The country is required'),
    state: yup.string().required('The state is required'),
    address_city: yup.string().required('The city is required'),
    address_line1: yup.string().required('The address is required'),
    address_zip: yup.string().required('The Zip code is required'),
    name: yup.string().required('The Name is required'),
    email: yup.string().required('The Email is required'),
});

const useStyles = makeStyles((theme) => ({
  tableContainer: {
    marginTop: 50,
  },
  info:{
	display: 'grid',
	gridTemplateColumns: "1fr minmax(100px, auto)",
	gap: '20px',
	"@media (max-width: 767px)": {
		display: 'flex',
		flexDirection: 'column !important',
	}
  },
  table: {
	border: '1px solid rgba(0, 0, 0, 0.87) !important',
	borderBottom: '0',
  },
  tableRow: {
    display: "grid",
    gridTemplateColumns: "minmax(350px, auto) minmax(250px, auto) 150px",
	borderBottom: '1px solid rgba(0, 0, 0, 0.87)',
	"@media (max-width: 1000px)": {
		gridTemplateColumns: "minmax(250px, auto) 150px 100px",
	},
	"@media (max-width: 600px)": {
		gridTemplateColumns: "1fr 100px",
	},
  },
  tableRowSecond: {
    display: "grid",
    gridTemplateColumns: "1fr 150px",
	"@media (max-width: 1000px)": {
		gridTemplateColumns: "1fr 100px",
	},
  },
  borderRight: {
	borderRight: '1px solid rgba(0, 0, 0, 0.87)',
	"@media (max-width: 600px)": {
		textAlign: 'left !important'
	}
  },

	accordionTitle: {
		fontWeight: '600 !important',
		fontSize: '22px',
		fontStyle: 'italic'
	},
	arrowIcon: {
		transition: "transform 0.3s",
		fontSize: '2.6rem'
	},
	arrowOpen: {
		transform: "rotate(90deg)",
	},
	cellsPayment: {
		fontSize: '1.4rem !important',
		verticalAlign: 'middle !important'
	},
	fileLabel: {
		position: 'relative',
		border: '1px solid rgba(0, 0, 0, 0.87)',
		borderRadius: '5px',
		maxWidth: '280px',
		width: '100%',
		display: 'flex'
	},
	fileLabelButton: {
		borderLeft: '1px solid rgba(0, 0, 0, 0.87)',
		padding: '5px 10px',
		whiteSpace: 'nowrap',
		height: 'auto',
		display: 'flex',
		alignItems: 'center',
		fontSize: '1.4rem !important'
	},
	fileInput: {
		position: 'absolute',
		top: '0',
		left: '0',
		width: '100%',
		height: '100%',
		opacity: '0',
		fontSize:' 0',
		cursor: 'pointer',
	},
	form: {
		marginTop: '30px',
		display: 'flex',
		gap: '10px',
		justifyContent: 'space-between',
		"@media (max-width: 600px)": {
			flexDirection: 'column',
		}
	},
	fileTextWrapper: {
		whiteSpace: 'nowrap',
		overflow: 'hidden',
        textOverflow: 'ellipsis',
		display: 'flex',
		alignItems: 'center',
		padding: '5px 10px',
		flex: '1 1 auto',
	},
	errorText: {
		position: 'absolute',
		bottom: '-15px',
		left: 0,
		color: 'red'
	},
	uploadFileList: {
		listStyleType: 'none',
		padding: 0,
		margin: 0
	},
	uploadFileListLi: {
		position: 'relative',
		paddingLeft: '25px',
		display: 'flex',
    	alignItems: 'center',
		fontSize: '16px'
	},
	checkIcon: {
		color: 'green',
		position: 'absolute',
		left: 0,
	},
}));

const ExtraPark = () => {
    ValidateAccess();
    const dispatch = useDispatch();
    const {id} = useParams();
    const {booking, form} = useSelector(state => state.bookingForm);
    const isAuth = useIsAuthenticated();
    const history = useHistory();
	const classes = useStyles();

	const [expanded, setExpanded] = useState([]);
	const [selectedFiles, setSelectedFiles] = useState([]);
    const [error, setError] = useState('');
    const [parkFee, setParkFee] = useState({});
    const [uploadFiles, setUploadFiles] = useState([]);
	

	const {stripeKey} = window;
	const [stripePromise, setStripePromise] = useState(false);
	const [formattedDate, setFormattedDate] = useState('');
	const [payThisMuch, setPayThisMuch] = useState(0.0);
	const [billingDetails, setBillingDetails] = useState({
		country: '',
		state: '',
		address_city: '',
		address_line1: '',
		address_line2: '',
		address_zip: '',
		email: '',
		name: ''
	});
	const [currentPrice, setCurrentPrice] = useState(0.0);


	const [windowWidth, setWindowWidth] = useState(window.innerWidth);
	const [longDescriptionParts, setLongDescriptionParts] = useState([]);

	  useEffect(() => {
		if(Object.keys(parkFee).length > 0 && parkFee?.ParkFeeCalculation.longDescription?.includes('[CLICK HERE]')){
			const data = parkFee.ParkFeeCalculation.longDescription.split('[CLICK HERE]');
			
			setLongDescriptionParts(data);
		}
	  }, [parkFee]);
	

	useEffect(() => {
		const handleResize = () => {
		setWindowWidth(window.innerWidth);
		};

		window.addEventListener('resize', handleResize);

		return () => {
		window.removeEventListener('resize', handleResize);
		};
	}, []);

	const handleChange = (panel) => (event, isExpanded) => {
		setExpanded((prev) =>
			isExpanded
			? [...prev, panel]
			: prev.filter((item) => item !== panel)
		);
	};

    useEffect(() => {
        dispatch(setStep(4));
		setStripePromise(loadStripe(stripeKey));
    }, []);


    useEffect(() => {
        if (!booking || form.guestFk !== parseInt(id))
            getGuestAndTrip().catch();
        if (booking && booking?.trip?.location?.tripTypeFk === 2)
            return history.push(`/booking/guest/${id}/medical-insurance`);
    }, [booking?.id]);

    const getGuestAndTrip = async () => {
        const accessToken = sessionStorage.getItem('accessToken');
        dispatch(getBookingFormData(id, accessToken));
    };

	function calculateLeftToPay(data) {
		const leftToPay =  parseFloat(data.GuestParkFee.ParkFeeCalculation.leftToPay);

		return leftToPay > 0 ? leftToPay : 0;
	}

	const fetchParkFee = async () => {
		if (id) {
			try {
				const accessToken = sessionStorage.getItem('accessToken');
				const accessQuery = accessToken ? `?access=${accessToken}` : '';
				const { data } = await requestApi(`/guest/get-parkfee/${id}${accessQuery}`);
				if (data.status === 'success' && data.GuestParkFee !== null) {
					setFormattedDate(format(parseISO(data.GuestParkFee.ParkFeeCalculation.startdate), "dd MMM yyyy"));
					setParkFee(data.GuestParkFee);
					setUploadFiles(JSON.parse(data.GuestParkFee.uploadFiles));

					setCurrentPrice(calculateLeftToPay(data));
					
				}
			} catch (error) {
				console.error("Error fetching park fee:", error);
			}
		}
	};

    useEffect(() => {
		fetchParkFee();
	}, [id]);


    const handlerPayThis = () => {
        setPayThisMuch(parseFloat(currentPrice));
    };
	

	const handleFileChange = (event) => {
		const files = Array.from(event.target.files);
		setSelectedFiles(files);
	};

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!selectedFiles) {
            setError('Please choose a file to upload.');
            return;
        }

        try {
            const formData = new FormData();
			selectedFiles.forEach(file => formData.append('files[]', file));

			const response = await requestApi(`/guest/park-fee-upload/${id}`, 'POST', formData);
			
			showAlertAutoDis({ title: 'Success', text: 'Files uploaded successfully'}, () => {
				setSelectedFiles([]);
				fetchParkFee();
			});
        } catch (error) {
            console.error("Error sending file:", error);
			showAlertAutoDis({title: 'Failed to send the file. Please try again.'});
        }
    };

	const moveToStepBack = () => {
		let url = `/booking/guest/${id}/diving`;
        return history.push(url);
	};
	const moveToStep = () => {
		let url = `/booking/guest/${id}/extra-activities`;
        return history.push(url);
	};

	const setDetails = (event) => {
		setBillingDetails({...billingDetails, [event.target.name]: event.target.value});
	};

	const sendStripeToken = async (token) => {
			if (!await validateForm(billingDetailsValidation, billingDetails, 'Billing Details Form')) return;
			const paymentData = {
				amount: payThisMuch,
				billingDetails
			};
	
			const {
				name,
				brand,
				address_line1,
				address_city,
				address_zip,
				cvc_check,
				address_zip_check,
				country,
				last4
			} = token.card;
	
			paymentData.cardInfo = {
				name,
				brand,
				address_line1,
				address_city,
				address_zip,
				cvc_check,
				address_zip_check,
				country,
				last4
			};
	
			paymentData.token = token.id
			paymentData.created = token.created;
	
			const url = `/guest/park-fee-payment/${id}`;
			const {data} = await requestApi(url, 'POST', paymentData);
			let successPayment = false;
	
			if ('status' in data && data['status'] === 'success') {
				successPayment = !!data?.successPayment;
				if (successPayment)
					showAlertAutoDis({title: 'Success', text: 'Payment successful', manualClose: true}, () => {
						//Todo: Refresh the table with the payments
						fetchParkFee();
					});
			} else if ('message' in data)
				showAlertAutoDis({title: 'Error', text: data['message']});
	};

    return (
        <>
            {isAuth() && booking && <GuestBar>
                <Breadcrumbs aria-label="breadcrumb" separator={'>'}>
                    <Link component={RouterLink} underline="hover" color="inherit" to="/booking/my-bookings">
                        Bookings
                    </Link>
                    <Link component={RouterLink} underline="hover" color="inherit" to={`/booking/my-bookings/${booking.id}`}>
                        {format(parse(booking.tripDate, 'yyyy-MM-dd', new Date()), 'LLLL d, yyyy')}
                    </Link>
                    <Typography color="text.primary">{form?.guestInfo?.firstName ? `${form.guestInfo.firstName} ${form.guestInfo.lastName}` : 'Guest Form'}</Typography>
                </Breadcrumbs>
            </GuestBar>}
            {booking && <Container>
                <GuestInfoStepper/>
                <div style={{marginTop: 50}}>
                    <Grid container spacing={3} sx={{px: {xs: '1.6rem', lg: '0'}}}>
                        <Grid item xs={12} sm={12}>
                            {booking.trip && <PreTripCard booking={booking}/>}
                        </Grid>
                        {parkFee?.ParkFeeCalculation?.longDescription?.includes('[CLICK HERE]') && parkFee.ParkFeeCalculation.longDescription.includes('**') && longDescriptionParts.length > 0 ?
						<Grid item xs={12} className={classes.info}>
							<Typography variant='p'>
								{longDescriptionParts[0].split(/\*\*(.*?)\*\*/).map((part, index) =>
									index % 2 === 1 ? <strong key={index}>{part}</strong> : part
								)}
								<a
									style={{ color: '#448aff', textDecoration: 'none' }}
									href="https://nautilusliveaboards.com/wp-content/uploads/2025/01/2025-01-20-Mexico-Park-Fees.pdf"
									target="_blank"
									rel="noopener noreferrer"
								>
									[Click Here]
								</a>
								{longDescriptionParts[1].split(/\*\*(.*?)\*\*/).map((part, index) =>
									index % 2 === 1 ? <strong key={index}>{part}</strong> : part
								)}
							</Typography>
							<div>
								<img src={`${window['appBasename']}/images/conanp.png`} alt='conanp'/>
							</div>
						</Grid> :
						parkFee.longDescription && <Grid item xs={12} className={classes.info}>
							<Typography variant='p'>
								{parkFee.ParkFeeCalculation.longDescription}
								<a
									style={{ color: '#448aff', textDecoration: 'none' }}
									href="https://nautilusliveaboards.com/wp-content/uploads/2025/01/2025-01-20-Mexico-Park-Fees.pdf"
									target="_blank"
									rel="noopener noreferrer"
								>
									[Click Here]
								</a>
							</Typography>
							<div>
								<img src={`${window['appBasename']}/images/conanp.png`} alt='conanp'/>
							</div>
						</Grid>
						}
						{Object.keys(parkFee).length > 0 && <>
							<Grid item xs={12}>
								<div className={classes.tableContainer}>
									<div className={classes.table}>
										{/* Header Row */}
										<div className={`${classes.tableRow} ${classes.firstColumn}`} style={{backgroundColor: '#000'}}>
											<div className={classes.borderRight} style={{ padding: '5px 7px', minHeight:'35px', color: '#fff'}}></div>
											{windowWidth > 600 && <div className={classes.borderRight} style={{ textAlign: 'center', padding: '5px 7px', minHeight:'35px', color: '#fff' }}>Days in the park</div>}
											<div style={{ padding: '5px 7px', minHeight:'35px', color: '#fff' }}>Total</div>
										</div>

										{/* Data Row */}
										<div className={classes.tableRow} style={{backgroundColor: windowWidth > 600 ? '#FFFFFF' : '#F2F2F2'}}>
											<div className={classes.borderRight} style={{ padding: '5px 7px', minHeight:'35px' }}>
												{parkFee.ParkFeeCalculation.description}{" "}
												{parseFloat(parkFee.discount) > 0 && parseFloat(parkFee.discount) < 1 ? (
													<strong>
														{/*Discounted Price: <strong>${parkFee.ParkFeeCalculation.perDay}/person/day</strong>*/}
														Discounted fee per park rules
													</strong>
												) : parseInt(parkFee.discount) === 1 ? (
														<strong>Exempted from fee per park rules</strong>
												) : (
													`$${parkFee.ParkFeeCalculation.perDay}/person/day`
												)}
												{/* {parkFee.ParkFeeCalculation.description + ' $' + parkFee.ParkFeeCalculation.perDay}/person/day */}
											</div>
											{window.innerWidth > 600 && <div className={classes.borderRight} style={{ textAlign: 'center', padding: '5px 7px', minHeight:'35px' }}>
											{parkFee.ParkFeeCalculation.realDivingDays}
											</div>}
											<div style={{ padding: '5px 7px', minHeight:'35px' }}>
											${parkFee.ParkFeeCalculation.total}
											</div>
										</div>

										{/* Mobile-only row for days in the park */}
										{windowWidth <= 600 && (
											<div className={classes.tableRowSecond} style={{borderBottom: '1px solid rgba(0, 0, 0, 0.87)', backgroundColor: parkFee.transactions.length > 0 ? '#FFFFFF' : '#F2F2F2'}}>
											<div className={classes.borderRight} style={{ padding: '5px 7px', minHeight:'35px' }}>
												Days in the park
											</div>
											<div style={{ padding: '5px 7px', minHeight:'35px' }}>
												{parkFee.ParkFeeCalculation.realDivingDays}
											</div>
											</div>
										)}

										{parkFee.transactions.length > 0 && parkFee.transactions.map((transaction, index) => (
											<div 
											className={classes.tableRowSecond} 
											style={{
												borderBottom: '1px solid rgba(0, 0, 0, 0.87)', 
												backgroundColor: index % 2 === 0 ? '#F2F2F2' : '#FFFFFF'
											}} 
											key={transaction.id}
											>
											<div className={classes.borderRight} style={{ padding: '5px 7px', minHeight:'35px' }}>
												Payment {transaction.received} (Park Fee)
											</div>
											<div style={{ padding: '5px 7px', minHeight:'35px' }}>
												${transaction.amount}
											</div>
											</div>
										))}

										{/* Balance owing row */}
										{(parkFee.transactions.length > 0) && (
											<div 
											className={classes.tableRowSecond} 
											style={{
												borderBottom: '1px solid rgba(0, 0, 0, 0.87)', 
												backgroundColor: parkFee.transactions.length > 1 ? '#F2F2F2' : 'transparent'
											}}
											>
											<div className={classes.borderRight} style={{ padding: '5px 7px', minHeight:'35px' }}>
												<strong>Balance owing</strong>
											</div>
											<div style={{ padding: '5px 7px', minHeight:'35px' }}>
												${currentPrice}
											</div>
											</div>
										)}
										</div>

								</div>
							</Grid>
							<Grid item xs={12}>
								{currentPrice !== 0 && <Accordion
									expanded={expanded.includes("panel1")}
									onChange={handleChange("panel1")}
									style={{ boxShadow: 'none'}}
								>
									<AccordionSummary
										expandIcon={
											<ExpandMoreIcon
												className={
													expanded.includes("panel1")
														? `${classes.arrowIcon} ${classes.arrowOpen}`
														: classes.arrowIcon
												}
												sx={{ fontSize: '3rem !important' }}
											/>
										}
										sx={{backgroundColor: "#E8E8E8"}}
									>
										<Typography className={classes.accordionTitle}>Government park fees can be paid in Cabo prior to departure Or click here to pay national park fee now.</Typography>
									</AccordionSummary>
									<AccordionDetails>
										<Typography variant="body1">
											Icarus Aviation dba Nautilus Explorer - Nautilus Liveaboards, Nautilus Dive Adventures, a Canadian company
											Please note that while this transaction will be processed in US dollars via our U.S. Bank account, some clients' bank/credit card companies have charged a "foreign transaction fee" because we are a Canadian company.
										</Typography>
										<Typography variant="body1" style={{ marginTop: '30px' }}>
											All transactions are made in US Dollars. We accept Visa, Mastercard, and American Express.
										</Typography>
										<Grid item xs>
											<div className="center" style={{marginTop: '50px'}}>
												<img src={`${window['appBasename']}/images/payment-methods.jpg`}
													 alt="Mastercard, Visa, American Express"
													 style={{height: 50, width: 233, margin: '1.5rem auto'}}/>
											</div>
										</Grid>
										<Grid item xs>
											<RadioGroup sx={{margin: '0 auto', maxWidth: '470px'}} aria-label="pay-options" name={'payThisMuch'} onChange={handlerPayThis}>
												<Table sx={{boxShadow: 'none'}} aria-label="simple table">
													<TableHead>
														<TableRow>
															<TableCell className={classes.cellsPayment} align="center">Payment</TableCell>
															<TableCell className={classes.cellsPayment} align="center">Amount</TableCell>
															<TableCell/>
														</TableRow>
													</TableHead>
													<TableBody>
														<TableRow>
															<TableCell className={classes.cellsPayment} align="center"><strong>Park Fee</strong></TableCell>
															<TableCell className={classes.cellsPayment} align="center" style={{whiteSpace: 'nowrap'}}
															>$ {currentPrice}</TableCell>
															<TableCell className={classes.cellsPayment}>
																<FormControlLabel
																	className={'cleanCheckbox'}
																	value={currentPrice}
																	control={<Radio color="primary"/>}
																	label={`Pay this`}/>
															</TableCell>
														</TableRow>
													</TableBody>
												</Table>
											</RadioGroup>
											{payThisMuch > 0 && <div style={{marginTop: 30}}>
												<Typography align={'center'} id="transition-modal-title" variant={'h3'}>
													Pay Now $ {payThisMuch.formatMoney()} USD
												</Typography>
												{stripePromise && <Elements stripe={stripePromise}>
													<ParkFeeCheckoutForm
														setBilling={setDetails}
														billingDetails={billingDetails}
														sendStripeToken={sendStripeToken}/>
												</Elements>}
											</div>}
										</Grid>
									</AccordionDetails>
								</Accordion>}

								{Object.keys(parkFee).length > 0 && parseInt(parkFee.parkFeeId) !== 22 && parkFee.ParkFeeCalculation.perDayReal>0&& <Accordion
									expanded={expanded.includes("panel2")}
									onChange={handleChange("panel2")}
									style={{boxShadow: 'none', marginBottom: '50px'}}
								>
									<AccordionSummary
										expandIcon={
											<ExpandMoreIcon
												className={
													expanded.includes("panel2")
														? `${classes.arrowIcon} ${classes.arrowOpen}`
														: classes.arrowIcon
												}
												sx={{fontSize: '3rem !important'}}
											/>
										}
										sx={{backgroundColor: "#E8E8E8"}}
									>
										<Typography className={classes.accordionTitle}>Discounts and exceptions to
											government park fee</Typography>
									</AccordionSummary>
									<AccordionDetails>
										<Typography variant="body1"
													sx={{marginTop: '30px', fontSize: '20px', fontWeight: '700'}}>Exceptions
											(No park fee):</Typography>
										<ul style={{marginTop: '0', paddingLeft: '20px'}}>
											<li>
												<Typography variant="body1">
													Minors of less than 12 years old
												</Typography>
											</li>
											<li>
												<Typography variant="body1">
													People with disability with current medical Certificate.
												</Typography>
											</li>
											<li>
												<Typography variant="body1">
													Elder people registered as that in the Mexican Institute (INAPAM)
												</Typography>
											</li>
											<li>
												<Typography variant="body1">
													Retired or pension beneficiary, The authorities will accept any
													official document stating “retired” or “pensioned”
												</Typography>
											</li>
										</ul>
										<Typography variant="body1" sx={{fontSize: '20px', fontWeight: '700'}}>
											US${parseFloat(parkFee.ParkFeeCalculation.perDayReal * 0.25).formatMoney()} per
											day in the park
										</Typography>
										<ul style={{marginTop: '0', paddingLeft: '20px'}}>
											<li>
												<Typography variant="body1">
													Active Students with a valid educational institution ID card and
													current date
												</Typography>
											</li>
											<li>
												<Typography variant="body1">
													Teachers with credentials including a valid ID card
												</Typography>
											</li>
											<li>
												<Typography variant="body1">
													People living in certain cities declared marginal by the government
												</Typography>
											</li>
										</ul>
										<Typography variant="body1" sx={{fontSize: '20px', fontWeight: '700'}}>
											US${parseFloat(parkFee.ParkFeeCalculation.perDayReal * 0.50).formatMoney()} per
											day in the park
										</Typography>
										<ul style={{marginTop: '0', paddingLeft: '20px'}}>
											<li>
												<Typography variant="body1">
													Mexican nationals (proof with passport, birth certificate or Mexican
													ID (INE) )
												</Typography>
											</li>
											<li>
												<Typography variant="body1">
													Non Mexican nationals but residents in Mexico <br/>
													(Proof of residency via Immigration Agency Credential - temporary or
													permanent residency)
												</Typography>
											</li>
										</ul>
										<Typography variant="body1" style={{marginTop: '30px', fontWeight: '700'}}>
											If you are eligible, please submit your documents below, and we will adjust
											the park fees upon verification. Please note: All exception documentation
											must be submitted at least three weeks before departure.
										</Typography>
										<Typography variant="body3" style={{marginTop: '5px'}}>
											(File maximum size: 3MB)
										</Typography>
										<form noValidate autoComplete='off' onSubmit={handleSubmit}
											  className={classes.form}>
											<div className={classes.fileLabel}>
												{error &&
													<Typography className={classes.errorText}>{error}</Typography>}
												{selectedFiles && selectedFiles.length > 0 ? (
													<div className={classes.fileTextWrapper}>
														{selectedFiles.map((file, index) => (
															<Typography key={index} variant="body2"
																		sx={{fontSize: '1.4rem !important'}}>
																{file.name}&nbsp;
															</Typography>
														))}
													</div>
												) : (
													<Typography variant="body2" sx={{fontSize: '1.4rem !important'}}
																className={classes.fileTextWrapper}>No files
														uploaded</Typography>
												)}
												<div className={classes.fileLabelButton}>Choose...</div>
												<input multiple type="file" name="files[]" className={classes.fileInput}
													   onChange={handleFileChange}/>
											</div>
											<Button
												type="submit"
												variant="contained"
												color="primary"
												sx={{
													padding: '3px 25px',
													borderRadius: '4px',
													backgroundColor: '#007AFF'
												}}
											>
												Submit
											</Button>
										</form>
										{uploadFiles?.length > 0 &&
											<div style={{fontSize: '16px', marginTop: '15px'}}>
												We already have:
												<ul className={classes.uploadFileList}>
													{uploadFiles.map(item => {
														const fileName = item.split("/").pop();
														return (
															<li key={item} className={classes.uploadFileListLi}>
																{fileName}
																<CheckCircle className={classes.checkIcon}/>
															</li>
														);
													})}
												</ul>
											</div>
										}
									</AccordionDetails>
								</Accordion>}
							</Grid>
						</>
						}


                    </Grid>
					<Grid container sx={{px: {xs: '1.6rem', lg: '0'}, display: 'flex', justifyContent: 'space-between', marginBottom: '30px'}}>
						<SecondaryButton onClick={moveToStepBack} style={{margin: 0}}>Back</SecondaryButton>
						<PrimaryButton style={{margin: 0}} onClick={moveToStep}>Next</PrimaryButton>
					</Grid>
                </div>
            </Container>}
        </>
    );
};

export default ExtraPark;